import { css } from "styled-components"

const mixins = {
  button: css`
    display: inline-block;

    border-radius: 2px;

    font-size: 2rem;
    font-weight: normal;
    opacity: 1;
    padding: 1rem 2rem;
    cursor: pointer;
    transition: all 0.3s ease;

    :hover {
      opacity: 0.8;
    }

    &.is-white {
    }
  `,
  boxShadow: css`
    box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 2px 0px,
      rgb(219, 227, 231) 0px 0px 0px 1px inset;
  `,
  text_ellipsis: css`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `,
  transition: css`
    transition: all 0.4s ease 0s;
  `,
  transitionBackground: css`
    transition: background 0.25s ease-in-out;
  `,
  overlay: css`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `,
  positionCenter: css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `,
  text_gradation: css`
    background-image: linear-gradient(100deg);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  `,
}

export default mixins
